import { Injectable } from '@angular/core';

import { ApiService }                    from '../api/api.service';
import { DomainVerificationStatusModel } from './models/domain-verification.status';
import { SessionService }                from '../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class EmailVerificationService {
  private _statuses = {
    notApplicable: 'na',
    notAttempted : null,
    pending      : 'pending',
    unverified   : 'unverified',
    verified     : 'verified'
  };

  constructor (
    private apiService     : ApiService,
    private sessionService : SessionService
  ) {}

  getCompany () : any {
    return this.sessionService.company();
  }

  getDomainFromEmail ( email ?: string ) : string {
    const domain = (email || '')
      .toLowerCase()
      .match(/@([^@\s]+)$/);

    return domain
      ? domain[ 1 ]
      : null;
  }

  getStatus ( company: any = this.getCompany() ) : DomainVerificationStatusModel {
    return company?.ses_domain_verified;
  }

  isDomainStatus ( status : string ) : boolean {
    return this.getStatus() === this._statuses[status];
  }

  verifyDomain () : Promise<boolean> {
    return this.isDomainStatus('notAttempted')
      ? this.apiService.get('/amazon_web_services/send_ses_domain_records')
      : this.apiService.get('/amazon_web_services/reactivate_ses_domain_search');
  }
}